/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/scenario-mapper/scenario-dialog',['require','jquery','underscore','screens/scenario-mapper/scenario-asset','core/engine'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  var _ = require('underscore');
  //var templates = require('core/templates');
  //var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioAsset = require('screens/scenario-mapper/scenario-asset');
  var Engine = require('core/engine');
  //var ScenarioLink = require('screens/scenario-mapper/scenario-link');
  //var ScenarioUtils = require(ScenarioU);
  var Scenario;
  require(['screens/scenario-mapper/scenario'], function(a) {
    Scenario = a;
  });
  var ScenarioUtils;
  require(['screens/scenario-mapper/scenario-utils'], function(a) {
    ScenarioUtils = a;
  });
  var ScenarioLink;
  require(['screens/scenario-mapper/scenario-link'], function(a) {
    ScenarioLink = a;
  });

  /*****************************************************************************************************************///}

  var ScenarioDialog = ScenarioAsset.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    stageMC: null,

    nodeType: null,
    parentConvo: null,

    isRoot: false,
    isGroup: false,

    name: null,
    title: null,
    mcName: null,
    description: null,
    menuText: null,
    dialogText: null,

    mp3Filename: null,
    itemFeedback: null,
    scenarioItem: null,
    isFeedback: false,
    feedbackFrame: null,

    isPresent: false,
    isPlayer: false,
    reputation: 0,
    actorID: null,

    conditionString: null,
    script: null,

    priority: 3,
    priorityIndex: 2,

    linksArr: [],

    contentAudio: null,
    isReady: false,
    wasDisplayed: false,

    audioReady: false,
    imageReady: false,
    mcAsset: null,

    mouthData: null,
    mouthArr: null,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(data, parentConvo)
    {
      ScenarioDialog.instancesArr.push(this);
      this.parentConvo = parentConvo;
      this.isReady = false;

      ScenarioAsset.prototype.initialize.apply(this, arguments);
    },

    activate: function()
    {
      ////console.log('activating dialog: ' + this.id);
      ScenarioDialog.activeDialog = this;
      if (Scenario.NODE_TYPE_FEEDBACK && !this.getAvailable())
      {
        this.checkBranches();// followLink(this.linksArr[0]);
      }
      else if (this.getAvailable())
      {
        this.wasDisplayed = true;
        this.checkScript();
        this.checkCaption();
        switch (this.nodeType)
        {
          case Scenario.NODE_TYPE_FOLLOW:
          case Scenario.NODE_TYPE_ROOT:
            this.followLink(this.linksArr[0]);
            break;
          case Scenario.NODE_TYPE_FEEDBACK:
            this.playFeedback();
            break;
          case Scenario.NODE_TYPE_TREE:
            this.checkBranches();
            break;
          case Scenario.NODE_TYPE_HOTSPOT:
            ////console.log('hotspot activated');
            break;
          case Scenario.NODE_TYPE_CHAT:
            ////console.log('chat activated');
            break;
          case Scenario.NODE_TYPE_ACTIVITY:
            //console.log('Activity activated');
            break;
          case Scenario.NODE_TYPE_ENDPOINT:
            Scenario.finishScenario();
            break;
          default:
            //console.log('node available: ' + this.nodeType);
            break;
        }
      }
      else
      {
        //console.log('ACTIVATE WHAT?');
      }
    },

    skipAudio: function()
    {
      if (this.contentAudio)
      {
        //console.warn('skip', this.channel);
        if (this.channel)
          this.channel.skip();
        //this.channel.player.off($.jPlayer.event.ended);
        //this.contentAudio.skip();
      }
      if (this.scenarioItem)
      {
        this.scenarioItem.skipFrames();
      }
    },

    killAudio: function()
    {
      if (this.contentAudio && this.channel)
      {
        //console.warn('skip', this.channel);
        this.channel.off($.jPlayer.event.ended);
        this.channel.stop();
        //this.contentAudio.skip();
      }
    },

    pause: function()
    {
      if (this.contentAudio)
      {
        this.contentAudio.pause();
      }
      else if (this.scenarioItem)
      {
        this.scenarioItem.pause();
      }
    },

    resume: function()
    {
      if (this.contentAudio)
      {
        this.contentAudio.resume();
      }
      else if (this.scenarioItem)
      {
        this.scenarioItem.resume();
      }
    },

    SimStatus: function()
    {
      return (this.wasDisplayed) ? 'WasDisplayed' : 'NA';
    },

    getAvailable: function()
    {
      var $avail = ScenarioUtils.evaluateConditionalStatement(this.conditionString);
      ////console.log('checking dialog availability: id, avail: ' + this.id, $avail);
      return $avail;
    },

    getPriorityArr: function()
    {
      var $pArr = [[], [], [], [], [], [], []];
      //var $link;
      var $dialog;

      _.forEach(this.linksArr, function($link) {
        $dialog = $link.destinationDialog();
        $pArr[$dialog.priorityIndex].push($link);
      });
      ////console.log('priorityArr', $pArr);
      return $pArr;
    },

    done: function()
    {

    },

    playFeedback: function()
    {
      Scenario.feedbackStarted(this);
      //this.parentConvo.bg.on(Event.ENTER_FRAME, onFrameHandler);
      if (this.itemFeedback !== null)
        this.playItemFeedback();
      else
        this.playAudioFeedback();
    },

    playAudioFeedback: function()
    {
      ////console.log('playAudioFeedback!!!!!!', this.media);
      var media = this.contentAudio;//this.mp3Filename;// || this.model.get('media');
      var callback = $.proxy(this.onFeedbackComplete, this);//callback || this.onMediaEnded;
      var options = {};//options || { };

      _.assign(options, _.omit(media, ['filename', 'caption', 'character']));

      ////console.log(options);

      if (media)
      {
        options.caption = {
          character: media.character,
          text: media.caption
        };
        //console.log('play audio, wait for ended');
        if (this.channel)
          this.channel.off($.jPlayer.event.ended);

        this.channel = Engine.module('Media').play(media.filename, options);
        //this.channel.off($.jPlayer.event.ended);
        var self = this;
        self.channel.on($.jPlayer.event.ended, $.proxy(callback, self));
      }
      else
      {
        console.error('No media found.');
        this.onFeedbackComplete();
      }
      ////console.log('feedback', this.parentConvo, ScenarioDialog.instancesArr);
      //setTimeout(this.onFeedbackComplete.bind(this), 500);
      //this.contentAudio.play(false);
    },

    playItemFeedback: function()
    {
      //var $captionStr = '<p><b>' + Scenario.getActorByID(this.actorID).name + ': </b>' + this.dialogText + '</p>';
      //var $itemArr = this.itemFeedback.split('.');
      //var $frameName = $itemArr[1];
      //this.scenarioItem = Scenario.getItemByName($itemArr[0]);

      //if (this.scenarioItem)
      //{
        //this.scenarioItem.playFrame($frameName, this.feedbackComplete);
        //TODO:Interface.setCaption($captionStr);
      //}
      //else
      //{
      //  console.error('Unable to play Item Feedback: ' + this.itemFeedback);
      //}

      var media = this.contentAudio;//this.mp3Filename;// || this.model.get('media');
      var callback = $.proxy(this.onFeedbackComplete, this);//callback || this.onMediaEnded;
      var options = {};//options || { };

      _.assign(options, _.omit(media, ['filename', 'caption', 'character']));

      //console.log('playing item feedback', this, this.scenarioItem);

      if (media)
      {
        options.caption = {
          character: media.character,
          text: media.caption
        };
      }

      if (this.scenarioItem.isMouth)
      {
        this.channel = Engine.module('Media').play(media.filename, options);
        this.channel.once($.jPlayer.event.ended, $.proxy(callback, this));

        if (this.scenarioItem)
        {
          this.channel.player.one($.jPlayer.event.playing, $.proxy(this.playingHandler, this));
        }
      }
      else
      {
        //console.log('non mouth feedback, audio in item.', media);
        Engine.module('Media').setCaption(options.caption);
        this.startItemFeedback(callback);
      }
    },

    checkCaption: function()
    {
      if (!this.dialogText || $.trim(this.dialogText) === '')
        return;
      //console.warn('check caption', this, this.dialogText);
      var caption = {
        text: this.dialogText,
        character: Scenario.getActorByID(this.actorID).name
      };
      Engine.module('Media').setCaption(caption);
    },

    pauseHandler: function(e)
    {
      if (!this.mouthArr)
        return;

      clearInterval(this.checkInt);
      this.renderMouth('closed');
    },

    startItemFeedback: function($callback)
    {
      this.scenarioItem.frameName(this.feedbackFrame);
      this.scenarioItem.playFrame(this.feedbackFrame, $callback);
    },

    playingHandler: function($e)
    {
      if (this.checkInt !== undefined)
        clearInterval(this.checkInt);

      if (this.scenarioItem.mouthEl && this.mouthArr)
        this.checkInt = setInterval($.proxy(this.onFrameHandler, this), 50);
      else if (!this.scenarioItem.mouthEl)
      {
        this.startItemFeedback();
      }
    },

    onFrameHandler: function()
    {
      ////console.log('status', this.channel.player.data('jPlayer'), this.channel.player.data().jPlayer.status);
      if (!this.channel)
      {
        clearInterval(this.checkInt);
        return false;
      }

      var $audioDiv = this.channel.player[0].getElementsByTagName('audio');
      var $curTime = 0;
      if ($audioDiv.length > 0)
        $curTime = this.channel.player[0].getElementsByTagName('audio')[0].currentTime;
      else
        $curTime = this.channel.player.data().jPlayer.status.currentTime;

      var $frameRate = 20;
      //console.log('time', $curTime);
      var $curFrame = Math.round($curTime * $frameRate);
      if (this.scenarioItem && this.mouthArr && this.scenarioItem.mcAsset)
        this.setItemMouth(this.mouthArr[$curFrame]);
    },

    setItemMouth: function($dataMouth)
    {
      //console.log('datamouth', $dataMouth);
      this.scenarioItem.mouthEl.attr('data-mouth', $dataMouth);
    },

    updateFeedbackProgress: function()
    {
      var $feedbackObj;
      if (this.itemFeedback)
      {
        $feedbackObj = this.scenarioItem;
      }
      else if (this.contentAudio)
      {
        $feedbackObj = this.contentAudio;
      }
      this.trigger(Scenario.UPDATE_FEEDBACK_PROGRESS, $feedbackObj);
    },

    onFeedbackComplete: function($e, $cAudio)
    {
      ////console.log('FEEDBACK COMPLETE!');
      if (this.channel)
        this.channel.off($.jPlayer.event.ended);
      else if (this.scenarioItem && this.scenarioItem.channel)
        this.scenarioItem.channel.off($.jPlayer.event.ended);

      this.feedbackComplete();
    },

    feedbackComplete: function()
    {
      //this.parentConvo.bg.removeEventListener(Event.ENTER_FRAME, onFrameHandler);
      clearInterval(this.checkInt);

      if (this.mouthData)
        this.setItemMouth('idle');

      if (this.scenarioItem && this.scenarioItem.mcAsset)
        this.scenarioItem.mcAsset.trigger('feedback.complete');

      Scenario.feedbackComplete();
      if (Scenario.singleton && !Scenario.singleton.ended)
      {
        this.checkBranches();
        //this.followLink(this.linksArr[0]);
      }
    },

    followLink: function($link)
    {
      ////console.log('following link');
      this.trigger('FOLLOW_DIALOG_LINK', $link);
    },

    checkBranches: function()
    {
      ////console.log('checking branches', this.linksArr);
      var $dialog;

      if (this.linksArr.length === 1)
      {
        this.followLink(this.linksArr[0]);
        return;
      }

      var $pArr = this.getPriorityArr();
      var $loop = true;
      var $linkArr;
      var $link;
      _.forEach($pArr, function($a) {
        if (!$loop)
          return false;

        $linkArr = $a;
        _.forEach($linkArr, function($b) {

          $link = $b;
          $dialog = $link.destinationDialog();
          ////console.log($dialog, $dialog.getAvailable());
          if ($dialog.getAvailable())
          {
            ////console.log('found it', $dialog);
            this.followLink($link);
            $loop = false;
            return false;
          }
        }, this);
      }, this);

      if (!$loop)
        return false;

      console.error('No available branch found, following last (convoID, dialogID): ' + $link.originConvo().id + ', ' + $link.destinationDialog().id);
      this.followLink($link);
    },

    checkScript: function()
    {
      ScenarioUtils.evaluateScriptStatement(this.script);
      Scenario.updateDebug();
      Scenario.updateDisplay();
    },

    evaluateType: function()
    {
      var $waitReady = false;
      var $link;
      this.audioReady = true;
      this.imageReady = true;
      ////console.log('evaluating type: ' + this.id, this.nodeColor);
      if (this.isRoot)
      {
        this.nodeType = Scenario.NODE_TYPE_ROOT;
      }
      else if (this.linksArr.length === 0)
      {
        this.nodeType = Scenario.NODE_TYPE_ENDPOINT;
      }
      else if (this.isFeedback)
      {
        ////console.log('feedback found', this.itemFeedback);
        this.nodeType = Scenario.NODE_TYPE_FEEDBACK;
        $waitReady = true;
        this.audioReady = false;
        if (!this.itemFeedback)
        {
          this.createContentAudio();
        }
        else
        {
          this.setupItemFeedback();
        }
      }
      else if (this.isGroup)
      {
        switch (this.nodeColor)
        {
          case Scenario.NODE_COLOR_PURPLE: // hotspot
            ////console.log('HOTSPOT');
            this.nodeType = Scenario.NODE_TYPE_HOTSPOT;
            break;
          case Scenario.NODE_COLOR_BLUE: // radial
            ////console.log('RADIAL');
            this.nodeType = Scenario.NODE_TYPE_RADIAL;
            break;
          case Scenario.NODE_COLOR_ORANGE: // chat
            this.nodeType = Scenario.NODE_TYPE_CHAT;
            break;
          case Scenario.NODE_COLOR_YELLOW: // activity
            this.nodeType = Scenario.NODE_TYPE_ACTIVITY;
            break;
        }
        ////console.log('GROUP NODE COLOR: ' + this.nodeColor);
      }
      else if (this.linksArr.length === 1)
      {
        $link = this.linksArr[0];
        if (this.isGroup && this.nodeColor === Scenario.NODE_COLOR_YELLOW)
        {
          this.nodeType = Scenario.NODE_TYPE_ACTIVITY;
        }
        /*else if (this.dialogText != '' || this.mp3Filename != '')
        {
          this.nodeType = Scenario.NODE_TYPE_FEEDBACK;
          $waitReady = true;
          if (!this.itemFeedback)
          {
            createContentAudio();
          }
          else
          {
            this.checkReady();
          }
        }*/
        else
        {
          this.nodeType = Scenario.NODE_TYPE_FOLLOW;
        }
      }
      else
      {
        if (this.nodeColor === Scenario.NODE_COLOR_ORANGE)
        {
          this.nodeType = Scenario.NODE_TYPE_CHAT;
        }
        else
        {
          this.nodeType = Scenario.NODE_TYPE_TREE;
        }
      }

      /*if (this.mcName !== undefined && this.mcName !== '' && this.mcName.indexOf('.') === -1)
      {
        this.imageReady = false;

        var $pathStr = this.parentConvo.bgImageName.replace('.swf', '') + '_' + this.mcName + '.png';
        this.imagePath = 'content/graphics/' + $pathStr;
        this.mcAsset = ScenarioUtils.findAssetInContainer(this.mcName, this.parentConvo.bg);

        var $mcImg = $('<img>').addClass('mc-image');
        $mcImg.on('load', $.proxy(this.onIMGLoadedHandler, this, $mcImg));
        $mcImg.on('error', $.proxy(this.onIMGLoadedHandler, this, $mcImg, false));
        $mcImg.attr('src', this.imagePath);
        this.mcImg = $mcImg;
        //console.log('mcasset', this.mcAsset);
        if (this.mcAsset)
          this.mcAsset.append($mcImg);
      }*/

      this.checkReady();
      ////console.log('Evaluated to: ' + this.nodeType);
      ////console.log('$_____');
    },

    onIMGLoadedHandler: function($img, $success)
    {
      $success = ($success === undefined) ? true : $success;

      if ($success)
      {
        //this.mcImg = $img;
        //add image to convo view $bgMC
      }
      else
      {
        console.error('Conversation BG Img not found: ', $img.attr('src'));
      }
      this.imageReady = true;
      this.checkReady();
    },

    checkReady: function()
    {
      if (this.imageReady === true && this.audioReady === true && this.isReady === false)
      {
        this.dialogReady();
      }
    },

    createContentAudio: function($mp3Filename)
    {
      $mp3Filename = ($mp3Filename === undefined) ? this.mp3Filename : $mp3Filename;
      ////console.log('createContentAudio');
      this.contentAudio = {
        caption: this.dialogText,
        character: Scenario.getActorByID(this.actorID).name,
        filename: $mp3Filename
      };

      // $.ajax({
      //   url: 'content/audio/' + $mp3Filename
      // }).always($.proxy(this.audioLoaded, this));
      this.audioLoaded();
    },

    audioLoaded: function()
    {
      this.audioReady = true;
      this.checkReady();
    },

    setupItemFeedback: function()
    {
      //console.log('setup item feedback', this);
      var $itemArr = this.itemFeedback.split('.');
      var $mp3Filename = $itemArr[1];

      this.scenarioItem = Scenario.getItemByName($itemArr[0]);
      this.feedbackFrame = $mp3Filename;

      if (!this.scenarioItem)
      {
        console.error('setupItemFeedback: cannot find scenarioItem', this.itemfeedback);
        this.audioReady = true;
        return;
      }

      //console.log('setting up item', this.scenarioItem);
      if (this.scenarioItem.mouthEl)
      {
        //console.log('setup mouth feedback', $mp3Filename);
        this.createMouthAudio($mp3Filename);
      }
      else
      {
        //console.log('setup animation feedback', $mp3Filename);
        if ($mp3Filename === 'shock')
        {
          this.audioReady = true;
        }
        else
        {
          this.createContentAudio($mp3Filename + '.mp3');
        }
      }
    },

    createMouthAudio: function($mp3Filename)
    {
      this.scenarioItem.isMouth = true;
      //this.scenarioItem.hasIdleFrame = true; // set in parseData in item

      //console.warn('createMouthAudio', this.scenarioItem);
      this.contentAudio = {
        caption: this.dialogText,
        character: Scenario.getActorByID(this.actorID).name,
        filename: $mp3Filename + '.mp3'
      };

      require(['json!content/audio/' + $mp3Filename + '.json?rand=' + Math.round(Math.random() * 10000)], $.proxy(this.audioDataLoaded, this, true), $.proxy(this.audioDataLoaded, this, false));
    },

    audioDataLoaded: function(success, data)
    {
      if (!success)
      {
        //console.error('failed to load json data for mouth', data);
       // ScenarioDialog.jsonErrorArr.push(_.omit(data, 'requireModules'));
        ScenarioDialog.jsonErrorArr.push({'Missing File': data.message});
        this.radio.trigger('check.connection');
      }
      else
      {
        this.mouthData = data;
        this.mouthArr = [];

        var $mouthArr = [];
        var $fullArr = data.spectrum;
        var $spectrumArr;
        //if (!$spectrumArr) return;

        var $bands = 16;
        var $startRange = 20;
        var $range = 9980;
        var $rangeDelta = $range / $bands;
        var $rangeAvg = $rangeDelta / 2;
        //console.log('setup mouth', $fullArr.length, this.contentAudio);

        for (var j = 0; j < $fullArr.length; j++)
        {
          if (data.amplitude[j] === 0)
          {
            $mouthArr.push('closed');
            continue;
          }

          var $f1 = 0;
          var $f2 = 0;
          var $p1 = 0;
          var $p2 = 0;
          var $peak;
          var $val;

          $spectrumArr = data.spectrum[j];

          for (var i = 0; i < $bands; i++)
          {
            $val = $startRange + $rangeAvg + ($rangeDelta * i);
            $peak = $spectrumArr[i];
            if ($peak > $p1)
            {
              $p2 = $p1;
              $f2 = $f1;
              $p1 = $peak;
              $f1 = $val;
            }
            else if ($peak > $p2)
            {
              $p2 = $peak;
              $f2 = $val;
            }
          }

          if ($f1 === 0 || $f2 === 0)
          {
            $mouthArr.push('closed');
            continue;
          }
          var $fRatio = $f2 / $f1;

          if ($f1 > 4000)
          {
            if ($fRatio < 0.8)
              $mouthArr.push('fv');
            else
              $mouthArr.push('sss');
          }
          else
          {
            if ($fRatio < 2)
              $mouthArr.push('oh');
            else if ($fRatio < 5.5)
              $mouthArr.push('ah');
            else
              $mouthArr.push('eh');
          }
        }

        this.mouthArr = $mouthArr;
      }

      this.audioReady = true;
      this.checkReady();
    },

    onAudioLoadedHandler: function($e)
    {
      ////console.log('AUDIO LOADED');
      this.contentAudio.off('CONTENT_LOADED', this.onAudioLoadedHandler);
      this.audioReady = true;
      this.checkReady();
    },

    dialogReady: function()
    {
      ////console.log('DIALOG READY');
      this.isReady = true;
      this.trigger('CONTENT_READY');
    },

    onBeforeDestroy: function()
    {
      this.stageMC = null;
      clearInterval(this.checkInt);
      this.checkInt = null;
      if (this.channel)
      {
        this.channel.stop();
        this.channel.player.off($.jPlayer.event.ended);
      }

      this.contentAudio = null;
      this.channel = null;
      this.parentConvo = null;
      this.scenarioItem = null;
    },

    parseData: function(data)
    {
      ScenarioAsset.prototype.parseData.apply(this, arguments);

      this.saType = ScenarioAsset.SA_TYPE_DIALOG;

      this.nlID = 'nl-' + this.parentConvo.id + '-' + this.id;

      this.isRoot = data.IsRoot;
      this.isGroup = data.IsGroup;

      this.nodeColor = Number(data.NodeColor);
      this.name = data.Fields.Name;
      this.mcName = data.Fields.mcName;

      this.description = data.Fields.Description;
      this.menuText = data.Fields['Menu Text'];
      if (this.menuText && this.menuText !== '')
      {
        this.menuText = this.menuText.replace(/(\[)(\w)*(\])/g, '');
      }

      if (this.menuText === '')
      {
        this.menuText = null;
      }

      var $rawText = data.Fields['Dialogue Text'];
      this.dialogText = (!$rawText || _.trim($rawText) === '' || $rawText.replace(/\[(\w|\s)*\]/gi, '') === '') ? '' : $rawText.replace(/\r\n/g, '<br />');
      //if ($rawText)
        ////console.log(this.dialogText, $rawText, $rawText.replace(/\[(\w|\s)*\]/gi, ''))

      this.itemFeedback = null;
      this.mp3Filename = null;
      var $rawMP3 = data.Fields.mp3File;
      if (!$rawMP3 || $rawMP3.indexOf('.') === -1)
      {
        ////console.log('is mp3file');
        this.mp3Filename = (!$rawMP3 || _.trim($rawMP3) === '') ? '' : $rawMP3 + '.mp3';
      }
      else
      {
        ////console.log('is itemfeedback');
        this.itemFeedback = $rawMP3;
      }

      this.actorID = data.Fields.Actor;

      if (this.actorID && (this.mp3Filename || this.itemFeedback))
      {
        this.isFeedback = true;
      }

      this.isPlayer = (data.Fields.IsPlayer === 'True');
      this.isPresent = (data.Fields.isPresent === 'True');
      this.reputation = Number(data.Fields.reputation);

      this.priority = data.ConditionPriority;
      this.priorityIndex = this.priority - 1;

      this.conditionString = data.ConditionsString.replace(/\r\n/g, ' ').replace(/\t/g, '');
      this.script = data.UserScript.replace(/\r\n/g, '&&').replace(/\t/g, '');
      ////console.log('dialog links', this.linksArr.length, this.id);
      this.linksArr = [];

      var $olObj;
      for (var $key in data.OutgoingLinks)
      {
        $olObj = data.OutgoingLinks[$key];
        this.linksArr.push(new ScenarioLink($olObj));
      }
    }

  /*****************************************************************************************************************///}

  });

  ScenarioDialog.instancesArr = [];
  ScenarioDialog.activeDialog = null;
  ScenarioDialog.jsonErrorArr = [];

  ScenarioDialog.getDialogByID = function($id, $convo)
  {
    $convo = $convo === undefined ? null : $convo;

    if (!$convo)
    {
      $convo = Scenario.singleton.activeConversation;
    }

    var $match = _.find(ScenarioDialog.instancesArr, function($sd) {
      if ($sd.id === $id && $sd.parentConvo.id === $convo.id)
        return true;
    });
    return $match || null;
  };

  ScenarioDialog.evaluateDialogNodes = function()
  {
    _.each(ScenarioDialog.instancesArr, function(dNode) {
      dNode.evaluateType();
    });
  };

  ScenarioDialog.destroy = function()
  {
    _.each(ScenarioDialog.instancesArr, function(instance) {
      instance.destroy();
    });

    ScenarioDialog.instancesArr = [];
    ScenarioDialog.jsonErrorArr = [];
  };

  return ScenarioDialog;

});

